import { toTitleCase } from './formatter';

const docTypeSpecialNameMap = {
    w9: 'w-9',
};

export const displayDocTypeNameMixin = {
    methods: {
        displayDocTypeName(docType: string): string {
            let name = docTypeSpecialNameMap[docType];

            // For all regular docTypes,
            // - convert underscores to spaces
            // - capitalize each word
            if (name === undefined) {
                name = docType.split('_').join(' ');
                name = toTitleCase(name);
            }
            return name;
        },
    },
};
